import React from "react";

import { useDemographics } from "~/sdks/LocalDemographics/context";

import { AverageIncome } from "./AverageIncome";
import { EmploymentStatus } from "./EmploymentStatus";
import { IncomeBrackets } from "./IncomeBrackets";

import * as styles from "../styles";

export const Income = () => {
  const {
    demographicsState: { income_level: incomeLevel },
  } = useDemographics();

  // Employment status and Income level only available in the USA
  return (
    <>
      {incomeLevel ? (
        <div className={styles.graphLayoutWrapper}>
          <div className={styles.graphSideBySide}>
            <div className={styles.graphContainer}>
              <AverageIncome />
            </div>
            <div className={styles.graphContainer}>
              <EmploymentStatus />
            </div>
          </div>
          <div className={styles.graphContainer}>
            <IncomeBrackets />
          </div>
        </div>
      ) : (
        <div className={styles.graphLayoutWrapper}>
          <div className={styles.graphContainer} data-size={"quarter"}>
            <AverageIncome />
          </div>
        </div>
      )}
    </>
  );
};
